import { useEffect, useState } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import liff from '@line/liff';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { LIFF_ID } from '../const';
import { analyticsService } from '../services/amplitude';
import { AppContextProvider } from '../stores/app';

import './styles.sass';
import '../utils/version-log';

import type { NextPageWithLayout } from '../types';
import type { AppProps } from 'next/app';

const queryClient = new QueryClient();

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

function CustomApp({ Component, pageProps }: AppPropsWithLayout) {
  const getLayout = Component.getLayout || ((page) => page);
  const [isLineInit, setIsLineInit] = useState(false);
  const { replace } = useRouter();

  useEffect(() => {
    analyticsService.init({
      lineOA: 'LINE車麻吉',
    });
  }, []);

  useEffect(() => {
    if (isLineInit) return;

    const initLiff = async () => {
      await liff.init({ liffId: LIFF_ID });

      setIsLineInit(true);
    };
    initLiff();
  }, [isLineInit, replace]);

  return (
    <>
      <Head>
        <title>Autopass 駕駛中心</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no,viewport-fit=cover, interactive-widget=resizes-content"
        />
        <meta name="theme-color" content="#F1F1F6" />
        <meta name="mobile-web-app-capable" content="yes" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <QueryClientProvider client={queryClient}>
        <AppContextProvider>
          {isLineInit ? (
            <main className="app">
              {getLayout(<Component {...pageProps} />)}
            </main>
          ) : null}
        </AppContextProvider>
      </QueryClientProvider>
    </>
  );
}

export default CustomApp;
